import { render, staticRenderFns } from "./Select2Ajax.vue?vue&type=template&id=10325e8d&scoped=true"
import script from "./Select2Ajax.vue?vue&type=script&lang=js"
export * from "./Select2Ajax.vue?vue&type=script&lang=js"
import style0 from "./Select2Ajax.vue?vue&type=style&index=0&id=10325e8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10325e8d",
  null
  
)

export default component.exports